import { theme } from 'src/config'
import styled, { css } from 'styled-components' 

type TableCounterProps = {
  variant: CounterVariants;
}

type CounterVariants = "milestone" | "meeting"

const CounterVariants = {
  milestone: css`
    background-color: ${theme.color.cards.milestone};
  `,
  meeting: css`
    background-color: ${theme.color.cards.meeting};
  `,
}

export const TableDataCounter = styled.div<TableCounterProps>`
  display:         flex;
  justify-content: center;
  align-items:     center;
  line-height:     1rem;
  position:        relative;
  height:          3rem;
  width:           3rem;
  margin:          auto;
  box-shadow:      none;
  cursor:          pointer;
  
  span {
    z-index: 1;
  }

  ::before {
    content:          '';
    display:          block;
    position:         absolute;
    z-index:          0;
    width:            100%;
    height:           100%;
    transform:        rotate(45deg);
    box-shadow:       ${theme.boxShadow.small};
    ${(props) => props.variant && CounterVariants[props.variant]};
  }
`;